var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatWeDo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.987,
    height: 27.07,
    viewBox: "0 0 26.987 27.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-commercial-building-2751900",
    transform: "translate(-2.5 -2.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(2.5 2.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M22.006,4.584h-.658l-1.18-1.967a.435.435,0,0,0-.373-.211h-7.6a.435.435,0,0,0-.373.211l-1.18,1.967H9.981a.435.435,0,0,0-.435.435v6.039H3.9a.435.435,0,0,0-.435.435V28.6H2.5v.871H29.487V28.6h-.969V11.494a.435.435,0,0,0-.435-.435H22.441V5.019A.435.435,0,0,0,22.006,4.584ZM12.441,3.276h7.107l.784,1.306H11.657Zm-8.1,8.653H9.546V28.6H4.34Zm6.077-6.475H21.571V28.6h-1.4v-6.12a.435.435,0,0,0-.435-.435H12.25a.435.435,0,0,0-.435.435V28.6h-1.4ZM12.685,22.92h2.874V28.6H12.685V22.92ZM16.429,28.6V22.92H19.3V28.6H16.429ZM27.648,11.929V28.6H22.441V11.929Z",
    transform: "translate(-2.5 -2.405)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 1.385,
    height: 0.871,
    transform: "translate(9.222 3.92)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 1.385,
    height: 0.871,
    transform: "translate(11.549 3.92)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 1.384,
    height: 0.871,
    transform: "translate(13.876 3.92)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 1.384,
    height: 0.871,
    transform: "translate(16.203 3.92)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 1.385,
    height: 0.871,
    transform: "translate(9.222 6.586)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 1.385,
    height: 0.871,
    transform: "translate(11.549 6.586)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 1.384,
    height: 0.871,
    transform: "translate(13.876 6.586)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 1.384,
    height: 0.871,
    transform: "translate(16.203 6.586)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 1.385,
    height: 0.871,
    transform: "translate(9.222 9.252)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 1.385,
    height: 0.871,
    transform: "translate(11.549 9.252)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 1.384,
    height: 0.871,
    transform: "translate(13.876 9.252)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 1.384,
    height: 0.871,
    transform: "translate(16.203 9.252)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 1.385,
    height: 0.871,
    transform: "translate(9.222 11.918)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 1.385,
    height: 0.871,
    transform: "translate(11.549 11.918)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 1.384,
    height: 0.871,
    transform: "translate(13.876 11.918)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 1.384,
    height: 0.871,
    transform: "translate(16.203 11.918)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 1.385,
    height: 0.871,
    transform: "translate(9.222 14.584)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 1.385,
    height: 0.871,
    transform: "translate(11.549 14.584)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 1.384,
    height: 0.871,
    transform: "translate(13.876 14.584)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 1.384,
    height: 0.871,
    transform: "translate(16.203 14.584)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 1.385,
    height: 0.871,
    transform: "translate(9.222 17.25)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 1.385,
    height: 0.871,
    transform: "translate(11.549 17.25)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 1.384,
    height: 0.871,
    transform: "translate(13.876 17.25)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 1.384,
    height: 0.871,
    transform: "translate(16.203 17.25)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 1.384,
    height: 0.871,
    transform: "translate(2.587 10.897)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 1.384,
    height: 0.871,
    transform: "translate(4.914 10.897)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 1.384,
    height: 0.871,
    transform: "translate(2.587 13.14)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 1.384,
    height: 0.871,
    transform: "translate(4.914 13.14)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 1.384,
    height: 0.871,
    transform: "translate(2.587 15.384)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 1.384,
    height: 0.871,
    transform: "translate(4.914 15.384)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 1.384,
    height: 0.871,
    transform: "translate(2.587 17.627)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 1.384,
    height: 0.871,
    transform: "translate(4.914 17.627)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 1.384,
    height: 0.871,
    transform: "translate(2.587 19.87)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 1.384,
    height: 0.871,
    transform: "translate(4.914 19.87)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 1.384,
    height: 0.871,
    transform: "translate(2.587 22.114)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 1.384,
    height: 0.871,
    transform: "translate(4.914 22.114)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 1.384,
    height: 0.871,
    transform: "translate(20.689 10.897)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 1.384,
    height: 0.871,
    transform: "translate(23.016 10.897)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 1.384,
    height: 0.871,
    transform: "translate(20.689 13.14)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 1.384,
    height: 0.871,
    transform: "translate(23.016 13.14)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 1.384,
    height: 0.871,
    transform: "translate(20.689 15.384)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 1.384,
    height: 0.871,
    transform: "translate(23.016 15.384)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 1.384,
    height: 0.871,
    transform: "translate(20.689 17.627)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 1.384,
    height: 0.871,
    transform: "translate(23.016 17.627)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 1.384,
    height: 0.871,
    transform: "translate(20.689 19.87)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 1.384,
    height: 0.871,
    transform: "translate(23.016 19.87)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 1.384,
    height: 0.871,
    transform: "translate(20.689 22.114)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 1.384,
    height: 0.871,
    transform: "translate(23.016 22.114)",
    fill: "#1c1c74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDo1);
export default __webpack_public_path__ + "static/media/whatWeDo1.a16cca9896fbc84330a62f6128f341f3.svg";
export { ForwardRef as ReactComponent };